export const customPaths = {
  biopsy: 'has_biopsy',
  treatments: 'treatments',
};
